@if (isOpen) {
  <div class="modal-backdrop" [class.fullscreen]="isFullscreen">
    <div class="modal-content"
      [style.max-width]="getModalWidth()"
      [class.fullscreen]="isFullscreen"
      [class.compacto]="compacto"
      [class.size-small]="size === 'small'"
      [class.size-medium]="size === 'medium'"
      [class.size-large]="size === 'large'"
      [class.size-flex]="size === 'flex'">
      <div class="modal-header" [class.compacto]="compacto">
        <h2>{{titulo}}</h2>
        <div class="header-actions">
          @if (permitirFullscreen) {
            <button class="fullscreen-btn" (click)="toggleFullscreen()" [title]="isFullscreen ? 'Sair da tela cheia' : 'Tela cheia'">
              <!-- Ícone expandir -->
              @if (!isFullscreen) {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
                </svg>
              }
              <!-- Ícone minimizar -->
              @if (isFullscreen) {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 9V4.5M9 9H4.5M9 9L3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5l5.25 5.25" />
                </svg>
              }
            </button>
          }
          <button class="close-btn" (click)="onClose()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-body" [class.compacto]="compacto">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
}
